import { render } from "./PrivacyModal.vue?vue&type=template&id=4de31eed"
import script from "./PrivacyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__